import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Cluster } from 'ol/source';
import { Style, Icon, Fill, Stroke, Text, RegularShape } from 'ol/style.js';

import ApiService from 'services/ApiService';
import { ToFeatures } from 'services/GeoJsonService';
import { isAccessCctv } from './CctvUtils';

export default class LayerFacilityAccessCctv extends VectorLayer {
    constructor(map, onDataLoaded) {
        const clusterStyle = function (feature) {
            const size = feature.get('features').length;

            if (size > 1) {
                return [
                    new Style({
                        image: new RegularShape({
                            points: 4,
                            radius: 24,
                            angle: Math.PI / 4,
                            fill: new Fill({ color: 'rgba(255, 193, 7, 0.95)' }),
                            stroke: new Stroke({ color: '#111827', width: 3 }),
                        }),
                        text: new Text({
                            font: 'bold 18px Pretendard, sans-serif',
                            text: size.toString(),
                            textBaseline: 'middle',
                            textAlign: 'center',
                            fill: new Fill({ color: '#111827' }),
                        }),
                        zIndex: 2,
                    }),
                ];
            }

            feature = feature.get('features')[0];
            const properties = feature.getProperties()?.properties;
            const stat = properties.hasAccessCctvError ? 0 : properties.stat;

            return new Style({
                image: new Icon({
                    anchor: [0.5, 0.5],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'fraction',
                    src: Number(stat) === 1
                        ? '/images/facility/access_cctv_active.png'
                        : '/images/facility/access_cctv_inactive.png',
                }),
                zIndex: 2,
            });
        };

        super({
            name: 'accessCctvLayer',
            source: new Cluster({
                distance: 120,
                minDistance: 80,
                source: new VectorSource(),
            }),
            visible: true,
            style: clusterStyle,
            userLayer: true,
            layerIndex: 0,
        });

        this.onDataLoaded = onDataLoaded;
        this.map = map;
        this.map?.addLayer(this);
        this.setData();
    }

    // DB 중앙 CCTV와 백엔드 설정의 방향별 카메라 정보를 결합합니다.
    setData = function () {
        ApiService.get(`newdashboard/gis/GetCCTV?_=${Date.now()}`).then(response => {
            if (response.status === 200) {
                const data = response.data;
                const dataset = [];

                for (let i = 0; i < data.rows.length; i++) {
                    const row = data.rows[i];

                    if (!isAccessCctv(row)) {
                        continue;
                    }

                    const id = String(row['cctvId']);

                                        dataset.push({
                        id,
                        x: row['x'],
                        y: row['y'],
                        nm: row['cctvLocation'],
                        stat: row['stat'],
                        type: 'accessCctv',
                        accessId: id,
                        accessName: row.accessConfig?.cctvLocation ?? row['cctvLocation'],
                        accessConfig: row.accessConfig,
                        // 중앙 CCTV 또는 방향별 카메라 중 하나라도 장애면 아이콘을 장애로 표시합니다.
                        hasAccessCctvError: Number(row['stat']) !== 1
                            || (row.accessConfig?.cameras ?? []).some(
                                camera => Number(camera.stat) !== 1
                            ),
                    });
                }

                let source = this.getSource();

                if (source instanceof Cluster) {
                    source = source.getSource();
                    source.clear();
                    source.addFeatures(ToFeatures(dataset));
                } else if (source instanceof VectorSource) {
                    source.clear();
                    source.addFeatures(ToFeatures(dataset));
                }

                this.onDataLoaded?.(dataset);
            }
        });
    }
}
